export const ouraRingDiscount = '10%'
